// Inventory API Client
// Based on backend/src/routes/inventory.js

import { apiClient } from './client';
import type {
  InventoryResponse,
  InventoryStatsResponse,
  UseItemRequest,
  UseItemResponse,
  InventoryItem
} from '../types/inventory';

export const inventoryAPI = {
  /**
   * GET /api/inventory
   * Get user's inventory
   */
  getInventory: async (): Promise<InventoryResponse> => {
    // Note: apiClient interceptor returns response.data directly
    return (await apiClient.get('/api/inventory')) as InventoryResponse;
  },

  /**
   * GET /api/inventory/stats
   * Get inventory statistics
   */
  getStats: async (): Promise<InventoryStatsResponse> => {
    return (await apiClient.get('/api/inventory/stats')) as InventoryStatsResponse;
  },

  /**
   * GET /api/inventory/:itemId
   * Get specific inventory item details
   */
  getItem: async (itemId: number): Promise<{ success: boolean; data: { item: InventoryItem } }> => {
    return await apiClient.get(`/api/inventory/${itemId}`);
  },

  /**
   * POST /api/inventory/use
   * Use/consume an item from inventory
   */
  useItem: async (data: UseItemRequest): Promise<UseItemResponse> => {
    return (await apiClient.post('/api/inventory/use', data)) as UseItemResponse;
  }
};
